var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyNestedFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 81,
    viewBox: "0 0 98 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1589 8.78711H12.2359C9.27165 8.78711 6.86914 11.1896 6.86914 14.1538V24.8873H89.1589V8.78711Z",
    fill: "#E2D5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1589 5.76907C89.1589 2.80485 86.7564 0.402344 83.7922 0.402344C76.2269 0.402344 62.5882 0.402344 55.7438 0.402344C53.1768 0.402344 50.8047 1.77801 49.531 4.00699C47.4183 7.70646 44.4362 12.9247 44.4362 12.9247H89.1589V5.76907Z",
    fill: "#E2D5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86914 13.8164H89.1589V17.1491H6.86914V13.8164Z",
    fill: "#AA7CFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.184 24.1433C95.4684 22.0932 94.8512 20.0198 93.4934 18.4599C92.1339 16.8982 90.1661 16.002 88.0963 16.002C69.8566 16.002 26.1714 16.002 7.93173 16.002C5.86196 16.002 3.89416 16.8982 2.53459 18.4599C1.17681 20.0198 0.559632 22.0932 0.844068 24.1433C2.65802 37.2023 6.17859 62.5476 7.80114 74.2327C8.29308 77.7694 11.3163 80.4027 14.8888 80.4027H81.1392C84.7117 80.4027 87.735 77.7694 88.2269 74.2327C89.8494 62.5476 93.37 37.2023 95.184 24.1433Z",
    fill: "#E2D5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44514 28.4724C1.57931 26.9823 2.17681 25.5583 3.17681 24.4098C4.53459 22.8499 6.50239 21.9537 8.57215 21.9537H87.4559C89.5257 21.9537 91.4934 22.8499 92.8512 24.4098C93.8512 25.5583 94.4487 26.9823 94.5829 28.4724L95.184 24.1433C95.4684 22.0932 94.8512 20.0198 93.4934 18.4599C92.1339 16.8982 90.1661 16.002 88.0963 16.002C69.8566 16.002 26.1714 16.002 7.93173 16.002C5.86196 16.002 3.89416 16.8982 2.53459 18.4599C1.17681 20.0198 0.559632 22.0932 0.844068 24.1433L1.44514 28.4724Z",
    fill: "#EFE9FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9657 62.5602C39.9657 60.5853 38.3646 58.9824 36.3879 58.9824C32.4183 58.9824 26.048 58.9824 22.0766 58.9824C20.1016 58.9824 18.4988 60.5853 18.4988 62.5602V66.1381C18.4988 68.1148 20.1016 69.7159 22.0766 69.7159H36.3879C38.3646 69.7159 39.9657 68.1148 39.9657 66.1381C39.9657 64.9878 39.9657 63.7123 39.9657 62.5602Z",
    fill: "#9B5AF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7976 28.9531C56.4309 28.9531 48.014 37.3699 48.014 47.7367C48.014 58.1034 56.4309 66.5202 66.7976 66.5202C77.1643 66.5202 85.5811 58.1034 85.5811 47.7367C85.5811 37.3699 77.1643 28.9531 66.7976 28.9531ZM66.7976 34.3199C74.2019 34.3199 80.2144 40.3324 80.2144 47.7367C80.2144 55.141 74.2019 61.1535 66.7976 61.1535C59.3933 61.1535 53.3808 55.141 53.3808 47.7367C53.3808 40.3324 59.3933 34.3199 66.7976 34.3199Z",
    fill: "#9B5AF8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5811 60.7081L93.2681 77.395C94.3164 78.4433 96.0158 78.4433 97.0641 77.395C98.1107 76.3485 98.1107 74.6472 97.0641 73.6007L80.3772 56.9138C79.3289 55.8673 77.6294 55.8673 76.5811 56.9138C75.5346 57.9603 75.5346 59.6616 76.5811 60.7081Z",
    fill: "#9B5AF8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNestedFolder);
export default __webpack_public_path__ + "static/media/EmptyNestedFolder.fd050216e864ac26a178965dbdd9f663.svg";
export { ForwardRef as ReactComponent };